// load remote modules from library, exposed using module federation
// cache for already loaded modules
const remoteMFModules = {}
export const loadRemoteMFModule = (scope, module) =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve, reject) => {
    const moduleKey = `${scope}_${module}`
    let RemoteModule = remoteMFModules[moduleKey]

    if (RemoteModule) {
      resolve(RemoteModule)
    } else {
      try {
        // Initializes the share scope. This fills it with known provided modules from this build and all remotes
        // eslint-disable-next-line no-underscore-dangle
        // eslint-disable-next-line no-undef
        await __webpack_init_sharing__('default')
        const container = window[scope] // or get the container somewhere else
        // Initialize the container, it may provide shared modules
        // eslint-disable-next-line no-underscore-dangle
        // eslint-disable-next-line no-undef
        await container.init(__webpack_share_scopes__.default)
        const factory = await window[scope].get(module)
        RemoteModule = factory()
        remoteMFModules[moduleKey] = RemoteModule
        resolve(RemoteModule)
      } catch (e) {
        reject(e)
      }
    }
  })

export const loadScript = (src, attributes = {}, force) => {
  if (!src) {
    // #todo: log error
    return false
  }
  return new Promise((resolve, reject) => {
    if (!force && document.getElementById(src)) {
      // #todo: log error
      resolve(
        'Script already added to page. Use forced parameter to load/execute the script '
      )
      return
    }
    const script = document.createElement('script')
    script.src = src
    script.id = src
    if (attributes.defer) {
      script.defer = true
    }
    if (attributes.async) {
      script.async = true
    }
    script.addEventListener('load', () => {
      setTimeout(() => {
        resolve()
      })
    })
    script.addEventListener('error', (e) => {
      reject(e)
    })
    document.head.appendChild(script)
  })
}

export const getParamNameValueString = (name, value, url = '') =>
  name && value ? `${url.includes('?') ? '&' : '?'}${name}=${value}` : ''

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
  if (!sources.length) {
    return target
  }
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: {} })
        }
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    })
  }

  return mergeDeep(target, ...sources)
}

// native implementation of _.get
export const getSafe = (obj, path, defaultValue = undefined) => {
  const travel = (regexp) =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce(
        (res, key) => (res !== null && res !== undefined ? res[key] : res),
        obj
      )
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/)
  return result === undefined || result === obj ? defaultValue : result
}
